<template>
  <NavBarAlert
    :loading="loading"
    theme="error"
    data-id="bad-subscription-banner"
  >
    <template #content>
      <p>
        <strong> Your subscription is {{ subscriptionState }}. </strong
        >{{ ' ' }}
        <button
          class="underline hover:no-underline"
          type="button"
          data-id="bad-status-open-billing"
          @click="openBilling"
        >
          Open billing to fix
        </button>
      </p>
    </template>
  </NavBarAlert>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useStore3 } from '~/store/main';

import { ref } from 'vue';
import NavBarAlert from '~/components/nav/NavBarAlert.vue';
import { loadFetch } from '~/lib/services/helpers';
import { Variant } from '~/store/_types';

const store = useStore3();
const { subscription, billingPortal } = storeToRefs(store);
const loading = ref(false);
const subscriptionState = computed(
  () => subscription?.value?.subscriptionStatus ?? 'unknown',
);
const openBilling = async () => {
  await loadFetch(() => store.getBillingPortal(), store, loading);
  await navigateTo(billingPortal.value?.url, {
    external: true,
  });
};
</script>
